// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GJpm","importantInfo":"styles_importantInfo__10xxH"};